<template>
    <div style="margin-top: 10px;">
        <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1">
                <template slot="title">
                    <span style="margin-left:10px">Data Definition</span>
                </template>
                <e-table  style="maring: 10px;" :headers="headers" :total="data.length" :data="data" :hideFooter="true"></e-table>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
    data: ()=> ({
        activeName: '1',
        headers: [
            {
                text: 'Column Name',
                value: 'columnName',
                width: '200'
            },
            {
                text: 'Definition & Use',
                value: 'definitionUse',
                width: '320'
            },
            {
                text: 'Accepted Values',
                value: 'acceptedValues',
                width: '385'
            },
            {
                text: 'Required?',
                value: 'required',
                width: 'auto'
            },
            {
                text: 'Example',
                value: 'example',
                width: '210'
            }
        ],
        data: [
            {
                columnName: 'VENDOR NAME',
                definitionUse: 'A name of a brand for a specific bill no.',
                acceptedValues: 'Text Value',
                example: 'Oakley Inc',
                required: 'Yes'
            },
            {
                columnName: 'BILL NO',
                definitionUse: 'This is important, you should not forget the bill no.',
                acceptedValues: 'Numeric value.',
                example: '2080180',
                required: 'Yes'
            },
            {
                columnName: 'BILL DATE',
                definitionUse: 'The date of the bill.',
                acceptedValues: 'Date format. (mm/dd/yyyy)',
                example: '11/6/2019',
                required: 'Yes'
            },
            {
                columnName: 'TERMS',
                definitionUse: 'The stated terms for a specific invoice.',
                acceptedValues: 'Text Value',
                example: 'NET 30',
                required: 'Yes'
            },
            {
                columnName: 'CATEGORY',
                definitionUse: 'A category for a specific brand or product.',
                acceptedValues: 'Inventory:ReStock Pro Inventory:Apparel,\nInventory:ShopKeep Inventory,\nCost of Goods Sold-Purchases',
                example: 'Cost of Goods Sold-Purchases',
                required: 'Yes'
            },
            {
                columnName: 'DESCRIPTION',
                definitionUse: 'An Invoice\'s PO should be encoded as description.',
                acceptedValues: 'Numeric Value',
                example: '2575145',
                required: 'Yes'
            },
            {
                columnName: 'AMOUNT',
                definitionUse: 'The bill\'s amount.',
                acceptedValues: 'Numeric Value. Also accepts with decimal points.',
                example: '10.00',
                required: 'Yes'
            },
            {
                columnName: 'CLASS',
                definitionUse: 'This class is provided by Extensiv',
                acceptedValues: 'Text Value',
                example: 'Active or Corporate',
                required: 'Yes'
            }
        ]
    })
}
</script>